(function (window, document, undefined) {
  'use strict';

  const $ = window.jQuery,
    console = window.console || {log: function () { }};

  let observer;
  let pagination, button, link, customVal, max, maxScroll, infinite;

  /**
   * Load next page fragment
   */
  function reload() {
    let page;
    const current_page = pagination.getAttribute('data-paged');
    const paged = parseInt(current_page) + 1;

    if (customVal !== '') {
      link = window.location.search;
      page = 'cv=' + customVal;
    } else {
      page = 'xhr-paging=1';
    }

    let url;

    if ( link.includes( '?' ) ) {
      url = link + '&' + page;
    } else {
      url = link + '?' + page;
    }

    axios.get(url)
      .then(result => success(result.data))
      .catch(error => fail(error));

    function success (result) {
      if (result !== null) {

        // add reloaded articles
        let getNodes = str => new DOMParser().parseFromString(str, 'text/html').body.childNodes;
        let node = getNodes(result);
        pagination.parentNode.insertBefore( node[0], pagination );

        if (
          (customVal !== '' && typeof(customVal) !== 'undefined') ||
          ( max !== '' && max <= current_page)
        ) {

          // remove pagination button
          pagination.parentNode.removeChild(pagination);
          // stop observing pagination
          if ( typeof(observer) !== "undefined" ) {
            observer.disconnect();
          }

        } else {

          // change data attribute for pagenumber
          pagination.setAttribute('data-paged', paged);
          // change link to next page for links like /page/2
          link = link.replace('/' + current_page, '/' + paged);
          // support for links like ?paged=2
          link = link.replace('paged=' + current_page, 'paged=' + paged);
          button.setAttribute('href', link);

        }

        // add event newPage when loading new page - required somewhere else
        let newPage_event = document.createEvent('Event');
        newPage_event.initEvent('newPage', true, true);
        document.dispatchEvent(newPage_event);

        console.log('Pagination - reload() - Page ' + current_page + ' loaded.');

      } else {
        console.log('Pagination - reload() - No articles to reload.');
      }
    };

    function fail(err) {
      console.log('Pagination - reload() - Reloading failed with (' + err + ')');
    };
  }

  /**
   * Initialize pagination including intersection observer
   */
  function init() {

    pagination = window.document.getElementById('vodl-pagination');
    button  = pagination.querySelector('a');
    link    = button.getAttribute('href');
    customVal = pagination.getAttribute('data-custom');
    max = parseInt(pagination.getAttribute('data-max'));

    infinite = false;

    button.onclick = function( evt ){
      evt.preventDefault();
      reload();
    };

    if ( pagination.getAttribute('data-infinite') ){

      maxScroll = parseInt( pagination.getAttribute('data-max-scroll') );
      if ( maxScroll !== null && maxScroll < max ) {
        // when scrolling is limited use this number instead of the maximum page number
        max = maxScroll;
      }

      infinite = true;

      // if pagination enters capturing frame reload next page
      let onIntersection = (entries, self) => {
        entries.forEach(entry => {
          if ( entry.isIntersecting ){
            reload();
          }
        });
      };

      // init intersectionObserver to observe pagination
      let rootMargin_ = '0px 0px ' + (window.innerHeight * 2) + 'px 0px';
      let observer_config = { rootMargin: rootMargin_, threshold: 0.01 };
      observer = new IntersectionObserver( onIntersection, observer_config);
      observer.observe(pagination);
    }

    console.log('Pagination - init() - Infinite scrolling: ' + infinite + ' (max: ' + max + ')');

  }

  window.Pagination = window.Pagination || {};
  $.extend( window.Pagination, {
    init: init
  } );

})(window, document);

$(document).ready(function () {
  if ( window.document.getElementById('vodl-pagination')) {
    window.Pagination.init();
  }
});
